import React, { useState, useEffect } from 'react';
import './ComingSoon.css';

const ComingSoon = () => {
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const registrationStartDate = new Date('2026-01-01T00:00:00');

    const calculateTimeRemaining = () => {
      const now = new Date();
      const difference = registrationStartDate - now;

      if (difference > 0) {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / 1000 / 60) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeRemaining({ days, hours, minutes, seconds });
      } else {
        setTimeRemaining({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        // Redirect to home page when registration opens
        window.location.href = '/';
      }
    };

    calculateTimeRemaining();
    const timer = setInterval(calculateTimeRemaining, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <div className="announcement-section">
          <h2 className="coming-soon-title">Registration Opening Soon!</h2>
          <p className="registration-date">January 1, 2026</p>
          <p className="description">
            We're excited to announce that applications for the BlueKraft Fellowship Program
            will open soon. Stay tuned for your opportunity to join our prestigious fellowship.
          </p>
        </div>

        <div className="countdown-section">
          <h3 className="countdown-label">Time Until Registration Opens:</h3>
          <div className="countdown-timer">
            <div className="time-unit">
              <div className="time-value">{timeRemaining.days}</div>
              <div className="time-label">Days</div>
            </div>
            <div className="time-separator">:</div>
            <div className="time-unit">
              <div className="time-value">{String(timeRemaining.hours).padStart(2, '0')}</div>
              <div className="time-label">Hours</div>
            </div>
            <div className="time-separator">:</div>
            <div className="time-unit">
              <div className="time-value">{String(timeRemaining.minutes).padStart(2, '0')}</div>
              <div className="time-label">Minutes</div>
            </div>
            <div className="time-separator">:</div>
            <div className="time-unit">
              <div className="time-value">{String(timeRemaining.seconds).padStart(2, '0')}</div>
              <div className="time-label">Seconds</div>
            </div>
          </div>
        </div>

        <div className="fellowship-info">
          <h3>Fellowship Programs Available:</h3>
          <ul className="fellowship-list">
            <li>BlueKraft Associate Fellowship</li>
            <li>BlueKraft Senior Fellowship</li>
            <li>BlueKraft Distinguished Fellowship</li>
          </ul>
        </div>

        <div className="contact-section">
          <p className="contact-text">
            For inquiries, please contact us at{' '}
            <a href="mailto:fellowship@bluekraft.com" className="contact-link">
              fellowship@bluekraft.com
            </a>
          </p>
        </div>
      </div>

      <div className="background-overlay"></div>
    </div>
  );
};

export default ComingSoon;
